import React, { useState, useContext, useEffect} from 'react';
import { Layout, Menu, Button } from 'antd';
import { TeamOutlined,LogoutOutlined, CarOutlined } from '@ant-design/icons';
import "antd/dist/antd.css";
import logo from '../utils/img/dyb.png'
import Rutas from './Rutas';
import UsuarioAdmin from './UsuarioAdmin';
import Title from 'antd/lib/typography/Title';
import { AuthContext } from '../context/Auth';
import UserProfile from './UserProfile';
import RutasAdmin from './RutasAdmin';
import app from '../utils/base';
import './css/styles.css'
import Axios from 'axios';
import { API_URL, GOOGLE_KEY } from '../context/constants';
const {  Sider, Header,Content } = Layout;

const Home = () => {
    const [collapsed,setCollapsed]=useState(true);
    const [currentItem,setCurrentItem]=useState('');
    const {currentUser,token}= useContext(AuthContext);
    const [alta,setAlta]=useState(true);
    // console.log(currentUser)
    // console.log(currentUser)
    useEffect(()=>{
      if(!token)
      return
      const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_KEY}&libraries=places`;
         document.head.appendChild(script);
      const pedirInfo=async()=>{
        const r=await Axios.get(`${API_URL}/profile/${currentUser.uid}`,{
          headers:{
            token
          }
        });
        if(r.data.alta){
          setAlta(true)
          setCurrentItem('usuarios')
        }
        else{
          setAlta(false)
        }
      }
      if (currentUser.email==="doyoubus@gmail.com")
        setCurrentItem('usuariosAdmin')
      else{
        
        pedirInfo()
      }
        
        // eslint-disable-next-line
    },[token])
    const onCollapse=()=>{
        setCollapsed(!collapsed)
    }
    return ( !alta?
      <div className="container">
        <img className="imagen" src={logo} alt="logo"/>
        <Title level={3}  style={{ margin: "15px",color:"#2B7BBC"}} >
        Su cuenta está dada de baja, para reactivarla, póngase en contacto con nosotros a través del siguiente enlace
        <br></br><a href="https://doyoubus.com/?page_id=152">https://doyoubus.com/?page_id=152 </a>
        </Title>
        <Button key="3" onClick={()=>app.auth().signOut()}>
                <LogoutOutlined />
                    <span>Cerrar Sesión</span>
        </Button>
        
    </div>
        :<Layout style={{ maxHeight: "100vh",maxWidth:"100vw" }} >  
          
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={onCollapse}
          
          theme='light'
          style={{
            maxWidth:"147pxs",
            maxHeight:"100vh",
            width:'10px',
         
          }}
          
        >

            {currentUser.email==="doyoubus@gmail.com"?
              <Menu style={{paddingTop:"60px"}} defaultSelectedKeys={['1']} mode="inline" >
                <Menu.Item   key="1" onClick={()=>setCurrentItem("usuariosAdmin")} >  
                  <TeamOutlined />
                    <span>Usuarios</span>                
                </Menu.Item>
                <Menu.Item key="2" onClick={()=>setCurrentItem("rutasAdmin")}>
                <CarOutlined />
                    <span>Rutas</span>
                </Menu.Item>
                <Menu.Item key="3" onClick={()=>app.auth().signOut()}>
                <LogoutOutlined />
                    <span>Cerrar Sesión</span>
                </Menu.Item>
              </Menu>
              :
              <Menu style={{paddingTop:"60px"}} defaultSelectedKeys={['1']} trigger="" mode="inline">
                <Menu.Item key="1" onClick={()=>setCurrentItem("usuarios")} >  
                  <TeamOutlined />
                    <span>Usuarios</span>                
                </Menu.Item>
                <Menu.Item key="2" onClick={()=>setCurrentItem("rutas")}>
                <CarOutlined />
                    <span>Rutas</span>
                </Menu.Item>
                <Menu.Item key="3" onClick={()=>app.auth().signOut()}>
                <LogoutOutlined />
                    <span>Cerrar Sesión</span>
                </Menu.Item>
              </Menu>
           
            }
          
        </Sider>
                <Layout style={{
                  height:"100vh",
                  width:"90%",
                  backgroundColor:'#'
                }}>
            <Header   style={{background:'#fff',position: 'fixed', zIndex: 1, width: '100vw', padding: 0  }}>
              <Title level={3}  style={{ margin: "15px",color:"#2B7BBC"}} >
                {
                    currentItem==="rutas"||currentItem==="rutasAdmin"?
                    <>Rutas</>
                    :
                    <>Usuarios</>
                }
                    </Title>
                    <img className="logo" src={logo} alt="logo"/>
                  </Header>
                  <Content style={{marginLeft:"30px", marginTop: 70}}>
                    {currentItem==="usuariosAdmin"&&<UsuarioAdmin/>}
                    {currentItem==="rutasAdmin"&&<RutasAdmin/> }
                    {currentItem==="usuarios"&&<UserProfile/>}
                    {currentItem==="rutas"&&<Rutas/> }
                  </Content>
                    
                </Layout>
        </Layout>
     );
}
 
export default Home;